import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, CreditCard, X } from "lucide-react";
import { api } from "../lib/api";
import { t } from "../i18n";

const KEY = "fl_last_order";
const WINDOW_HOURS = 6;

// A buyer can lose the trip back from the payment page (a gateway redirect that fails, a closed tab,
// a dead mobile connection). This bar brings them to their confirmation — or back to the payment.
export default function PaymentRescue() {
  const { locale = "en" } = useParams();
  const [row, setRow] = useState(null);
  const [status, setStatus] = useState("");
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let stored;
    try { stored = JSON.parse(localStorage.getItem(KEY) || "null"); } catch (_) { stored = null; }
    if (!stored?.session_id) return;
    if (stored.at && Date.now() - stored.at > WINDOW_HOURS * 3600 * 1000) {
      localStorage.removeItem(KEY);
      return;
    }
    setRow(stored);
    api.get(`/payments/status/${stored.session_id}`)
      .then((r) => setStatus(r.data.payment_status || ""))
      .catch(() => setStatus(""));
  }, []);

  if (!row || hidden || !status) return null;
  const paid = status === "paid";
  const number = (row.order_numbers || [])[0] || "";

  return (
    <div className="bg-ink text-plaster" data-testid="payment-rescue">
      <div className="mx-auto max-w-6xl px-5 py-2.5 flex items-center gap-3 text-sm">
        {paid ? <CheckCircle2 size={15} className="text-success shrink-0" />
              : <CreditCard size={15} className="text-brass shrink-0" />}
        <span className="flex-1">
          {paid ? t(locale, "rescuePaid").replace("{n}", number) : t(locale, "rescuePending")}
        </span>
        {paid ? (
          <Link to={`/${locale}/order/confirmed?session_id=${row.session_id}`}
                className="underline underline-offset-2 decoration-brass whitespace-nowrap"
                data-testid="payment-rescue-view">
            {t(locale, "rescueView")}
          </Link>
        ) : row.checkout_url ? (
          <a href={row.checkout_url} className="underline underline-offset-2 decoration-brass whitespace-nowrap"
             data-testid="payment-rescue-resume">
            {t(locale, "rescueResume")}
          </a>
        ) : null}
        <button onClick={() => setHidden(true)} aria-label="Dismiss" data-testid="payment-rescue-dismiss"
                className="text-plaster/60 hover:text-plaster transition-colors duration-150">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
